import { version } from '../../package.json';

const getAppVersion = () => {
  console.log(`[version] ${version}`);
};

getAppVersion();
